module.exports = __webpack_public_path__ + "img/sa.2520ca59.svg";